import Button from '../../Common/Button';
import columnOrder from '../../../../../src/assets/img/svg/buttons/columnOrder.svg';
import { useRef, useState } from 'react';
import { t } from 'i18next';
import ColumnOrderDropdown from './ColumnOrderDropdown';
import { useAppSelector } from '../../../../hook/useAppSelector';
import { useOutsideFocus } from '../../../../hook/useOutsideFocus';

const ColumnOrder: React.FC = () => {
  const [openColumnOrder, setColumnOrder] = useState(false);

  const isMobile = useAppSelector((state) => state.configSlice.isMobile);
  const menuRef = useRef<HTMLDivElement>(null);

  const openColumnOrderDropdown = () => {
    setColumnOrder((prevState) => !prevState);
  };

  useOutsideFocus(openColumnOrder, () => setColumnOrder(false), menuRef);

  return (
    <div data-pw="columnorder" className="column_order_wrapper">
      <div ref={menuRef}>
        <Button
          icon={columnOrder}
          onClick={openColumnOrderDropdown}
          variant={`${openColumnOrder ? 'filled' : ''}`}
          className="column_order_button"
        >
          <span className={`button_name ${openColumnOrder || isMobile ? 'visible' : ''}`}>
            {t('statisticPage.header.buttons.columnOrder')}
          </span>
        </Button>
        <ColumnOrderDropdown showDropdown={openColumnOrder} setShowDropdown={setColumnOrder} />
      </div>
    </div>
  );
};

export default ColumnOrder;
